// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import AdminSidebar from './AdminSidebar';
// import AdminHeader from './AdminHeader';
// import axios from 'axios';
// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';
// import dayjs from 'dayjs';

// const base_url = process.env.REACT_APP_API_URL;

// const UserBetHistory = () => {
//   const { user_phone } = useParams();
//  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
//  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const [sportsHistory, setSportsHistory] = useState([]);
//   const [fancyHistory, setFancyHistory] = useState([]);
//   const [filteredSports, setFilteredSports] = useState([]);
//   const [filteredFancy, setFilteredFancy] = useState([]);
//   const [statusFilter, setStatusFilter] = useState(null); // 1 = Win, 2 = Loss, 0 = Pending
//   const [fromDate, setFromDate] = useState(dayjs().subtract(7, 'day').format('YYYY-MM-DD'));
//   const [toDate, setToDate] = useState(dayjs().format('YYYY-MM-DD'));

//   const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

//   const fetchHistory = async () => {
//     const auth = localStorage.getItem('admin');
//     try {
//       const response = await axios.get(`${base_url}/api/webapi/pendingBetHistory?phone=${user_phone}`, {
//         headers: {
//           Accept: 'application/json',
//           Authorization: `${auth}`
//         }
//       });

//       if (response.data.success) {
//         const sports = response.data.allSports || [];
//         const fancy = response.data.allFancy || [];
//         setSportsHistory(sports);
//         setFancyHistory(fancy);
//       }
//     } catch (error) {
//       console.error('Fetch error:', error);
//     }
//   };

//   const applyFilters = (sports, fancy, status, from, to) => {
//     const fromTime = dayjs(from).startOf('day');
//     const toTime = dayjs(to).endOf('day');

//     const filterByDateAndStatus = (arr) =>
//       arr.filter(item => {
//         const time = dayjs(item.date);
//         const inDateRange = time.isAfter(fromTime) && time.isBefore(toTime);
//         const matchStatus = status === null ? true : item.status === status;
//         return inDateRange && matchStatus;
//       });

//     setFilteredSports(filterByDateAndStatus(sports));
//     setFilteredFancy(filterByDateAndStatus(fancy));
//   };

//   // Auto-apply filters when filter inputs change
//   useEffect(() => {
//     applyFilters(sportsHistory, fancyHistory, statusFilter, fromDate, toDate);
//   }, [statusFilter, fromDate, toDate, sportsHistory, fancyHistory]);

//   const downloadPDF = () => {
//     const doc = new jsPDF();
//     doc.setFontSize(14);
//     doc.text(`Bet History of: ${user_phone}`, 14, 15);

//     autoTable(doc, {
//       startY: 25,
//       head: [['User ID', 'Tournament', 'Match', 'Side', 'Odds', 'Stake', 'P/L', 'Status', 'Date']],
//       body: filteredSports.map(data => [
//         data.phone,
//         data.competitionName,
//         data.eventName,
//         data.side,
//         data.betprice,
//         data.betAmount,
//         data.profit,
//         data.status === 1 ? 'Win' : data.status === 2 ? 'Loss' : 'Pending',
//         data.date
//       ]),
//       theme: 'striped',
//       styles: { fontSize: 8 }
//     });

//     autoTable(doc, {
//       startY: doc.lastAutoTable.finalY + 10,
//       head: [['User ID', 'Market', 'Team', 'Runs', 'Rate', 'Type', 'Stake', 'P/L', 'Status', 'Date']],
//       body: filteredFancy.map(data => [
//         data.phone,
//         data.market,
//         data.team,
//         data.run,
//         data.rate,
//         data.type,
//         data.stake,
//         data.profit,
//         data.status === 1 ? 'Win' : data.status === 2 ? 'Loss' : 'Pending',
//         data.date
//       ]),
//       theme: 'striped',
//       styles: { fontSize: 8 }
//     });

//     doc.save(`BetHistory_${user_phone}.pdf`);
//   };

//   useEffect(() => {
//     fetchHistory();
//   }, []);

//   const pendingSum = (
//     filteredSports.filter(item => item.status === 0).reduce((acc, item) => acc + Number(item.betAmount), 0) +
//     filteredFancy.filter(item => item.status === 0).reduce((acc, item) => acc + Number(item.betAmount), 0)
//   ).toFixed(2);

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 768;
//       setIsMobile(mobile);

//       // On desktop, sidebar should always be "open"
//       if (!mobile) {
//         setIsSidebarOpen(true);
//       }
//     };

//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   return (
//   <div className="wrapper">
//     

//         {/* Content Wrapper - Use conditional class and margin */}
//         <div
//           className={`content-wrapper d-flex flex-column ${
//             !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
//           }`}
//           style={{
//             marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
//             transition: "margin-left 0.3s ease"
//           }}
//         >
//         <section className="content-header">
//           <div className="container-fluid">
//             <div className="row mb-2">
//               <div className="col-sm-6">
//                 <h1>Bet History of: {user_phone}</h1>
//               </div>
//             </div>
//           </div>
//         </section>

//         <div className="container-fluid">
//           <div className="card mb-3 p-3">
//             <div className="row g-3 align-items-center">
//               <div className="col-md-3">
//                 <label>From Date:</label>
//                 <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//               </div>
//               <div className="col-md-3">
//                 <label>To Date:</label>
//                 <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
//               </div>
//               <div className="col-md-4 d-flex align-items-end gap-2">
//                 <button className="btn btn-dark" onClick={() => setStatusFilter(null)}>All</button>
//                 <button className="btn btn-success" onClick={() => setStatusFilter(1)}>Win</button>
//                 <button className="btn btn-danger" onClick={() => setStatusFilter(2)}>Loss</button>
//                 <button className="btn btn-warning text-dark" onClick={() => setStatusFilter(0)}>Pending</button>
//               </div>
//               <div className="col-md-2 d-flex align-items-end gap-2">
//                 <button className="btn btn-secondary w-100" onClick={downloadPDF}>Download PDF</button>
//               </div>
//             </div>
//             {statusFilter === 0 && (
//               <div className="mt-3 text-center text-danger fs-5">
//                 Total Pending Bet Amount: ₹{pendingSum}
//               </div>
//             )}
//           </div>

//           {/* Sports Table */}
//           <div className="card mb-4">
//             <div className="card-header bg-primary text-white">Sports Bets</div>
//             <div className="card-body table-responsive">
//               <table className="table table-bordered table-sm">
//                 <thead>
//                   <tr>
//                     <th>User ID</th><th>Tournament</th><th>Match</th><th>Side</th><th>Odds</th>
//                     <th>Stake</th><th>P/L</th><th>Status</th><th>Placed At</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredSports.map(data => (
//                     <tr key={data.id}>
//                       <td>{data.playerId}</td>
//                       <td>{data.competitionName}</td>
//                       <td>{data.eventName}</td>
//                       <td><span className="px-2 text-white rounded" style={{ backgroundColor: data.side === 'Back' ? 'blue' : 'red' }}>{data.side}</span></td>
//                       <td>{data.betprice}</td>
//                       <td>{data.betAmount}</td>
//                       <td style={{ color: data.status === 1 ? 'green' : data.status === 2 ? 'red' : 'blue' }}>{data.profit}</td>
//                       <td><span className="px-2 text-white rounded" style={{ backgroundColor: data.status === 1 ? 'green' : data.status === 2 ? 'red' : 'gray' }}>{data.status === 1 ? 'Win' : data.status === 2 ? 'Loss' : 'Pending'}</span></td>
//                       <td>{data.date}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* Fancy Table */}
//           <div className="card">
//             <div className="card-header bg-warning text-white">Fancy Bets</div>
//             <div className="card-body table-responsive">
//               <table className="table table-bordered table-sm">
//                 <thead>
//                   <tr>
//                      <th>User ID</th><th>Tournament</th><th>Match</th><th>Side</th><th>Odds</th>
//                     <th>Stake</th><th>P/L</th><th>Status</th><th>Placed At</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredFancy.map(data => (
//                     <tr key={data.id}>
//                       <td>{data.phone}</td>
//                       <td>{data.competitionName}</td>
//                       <td>{data.eventName}</td>
//                       <td><span className="px-2 text-white rounded" style={{ backgroundColor: data.side === 'Back' ? 'blue' : 'red' }}>{data.side}</span></td>
//                       <td>{data.betprice}</td>
//                       <td>{data.betAmount}</td>
//                       <td style={{ color: data.status === 1 ? 'green' : data.status === 2 ? 'red' : 'blue' }}>{data.profit}</td>
//                       <td><span className="px-2 text-white rounded" style={{ backgroundColor: data.status === 1 ? 'green' : data.status === 2 ? 'red' : 'gray' }}>{data.status === 1 ? 'Win' : data.status === 2 ? 'Loss' : 'Pending'}</span></td>
//                       <td>{data.date}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserBetHistory;

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import dayjs from "dayjs";

const base_url = process.env.REACT_APP_API_URL;

const UserBetHistory = () => {
  const { user_phone } = useParams();
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    !(window.innerWidth < 768)
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [sportsHistory, setSportsHistory] = useState([]);
  const [fancyHistory, setFancyHistory] = useState([]);
  const [casinoHistory, setCasinoHistory] = useState([]);
  const [filteredSports, setFilteredSports] = useState([]);
  const [filteredFancy, setFilteredFancy] = useState([]);
  const [filteredCasino, setFilteredCasino] = useState([]);
  const [statusFilter, setStatusFilter] = useState(null);

  const [fromDate, setFromDate] = useState(
    dayjs().subtract(7, "day").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(dayjs().format("YYYY-MM-DD"));

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // ✅ Fetch data from APIs
  // const fetchHistory = async () => {
  //   const auth = localStorage.getItem("admin");
  //   try {
  //     const [sportsRes, casinoRes, fancyRes] = await Promise.all([
  //       axios.get(
  //         `${base_url}/api/webapi/pendingBetHistory?phone=${user_phone}`,
  //         {
  //           headers: { Accept: "application/json", Authorization: `${auth}` },
  //         }
  //       ),
  //       axios.get(
  //         `${base_url}/api/webapi/casinoBetHistory?phone=${user_phone}`,
  //         {
  //           headers: { Accept: "application/json", Authorization: `${auth}` },
  //         }
  //       ),
  //       axios.get(
  //         `${base_url}/api/webapi/casinoBetHistory?phone=${user_phone}`,
  //         {
  //           headers: { Accept: "application/json", Authorization: `${auth}` },
  //         }
  //       ),
  //     ]);

  //     if (sportsRes.data.success) {
  //       const sports = sportsRes.data.allSports || [];
  //       const fancy = sportsRes.data.allFancy || [];
  //       setSportsHistory(sports);
  //       setFancyHistory(fancy);
  //     }

  //     if (casinoRes.data.success) {
  //       const casino = casinoRes.data.allCasino || [];
  //       setCasinoHistory(casino);
  //     }
  //     if (fancyRes.data.success) {
  //       setFancyHistory(fancyRes.data.allFancy || []);
  //     }
  //   } catch (error) {
  //     console.error("Fetch error:", error);
  //   }
  // };

  const fetchHistory = async () => {
    const auth = localStorage.getItem("admin");
    try {
      const [sportsRes, casinoRes, fancyRes] = await Promise.all([
        axios.get(
          `${base_url}/api/webapi/pendingBetHistory?phone=${user_phone}`,
          {
            headers: { Accept: "application/json", Authorization: `${auth}` },
          }
        ),
        axios.get(
          `${base_url}/api/webapi/casinoBetHistory?phone=${user_phone}`,
          {
            headers: { Accept: "application/json", Authorization: `${auth}` },
          }
        ),
        axios.get(
          `${base_url}/api/webapi/fancyBetHistory?phone=${user_phone}`,
          {
            headers: { Accept: "application/json", Authorization: `${auth}` },
          }
        ),
      ]);

      if (sportsRes.data.success)
        setSportsHistory(sportsRes.data.allSports || []);
      if (casinoRes.data.success)
        setCasinoHistory(casinoRes.data.allCasino || []);
      if (fancyRes.data.success) setFancyHistory(fancyRes.data.allFancy || []);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  // ✅ Filter data by date and status
  const applyFilters = (sports, fancy, casino, status, from, to) => {
    const fromTime = dayjs(from).startOf("day");
    const toTime = dayjs(to).endOf("day");

    const filterByDateAndStatus = (arr) =>
      arr.filter((item) => {
        const time = dayjs(item.date);
        const inDateRange = time.isAfter(fromTime) && time.isBefore(toTime);
        const matchStatus = status === null ? true : item.status === status;
        return inDateRange && matchStatus;
      });

    setFilteredSports(filterByDateAndStatus(sports));
    setFilteredFancy(filterByDateAndStatus(fancy));
    setFilteredCasino(filterByDateAndStatus(casino));
  };

  useEffect(() => {
    applyFilters(
      sportsHistory,
      fancyHistory,
      casinoHistory,
      statusFilter,
      fromDate,
      toDate
    );
  }, [
    sportsHistory,
    fancyHistory,
    casinoHistory,
    statusFilter,
    fromDate,
    toDate,
  ]);

  useEffect(() => {
    fetchHistory();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const pendingSum = (
    filteredSports
      .filter((item) => item.status === 0)
      .reduce((acc, item) => acc + Number(item.betAmount), 0) +
    filteredFancy
      .filter((item) => item.status === 0)
      .reduce((acc, item) => acc + Number(item.betAmount), 0) +
    filteredCasino
      .filter((item) => item.status === 0)
      .reduce((acc, item) => acc + Number(item.betAmount), 0)
  ).toFixed(2);

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text(`Bet History of: ${user_phone}`, 14, 15);

    autoTable(doc, {
      startY: 25,
      head: [
        [
          "User ID",
          "Tournament",
          "Match",
          "Side",
          "Odds",
          "Stake",
          "P/L",
          "Status",
          "Date",
        ],
      ],
      body: filteredSports.map((d) => [
        d.playerId,
        d.competitionName,
        d.eventName,
        d.side,
        d.betprice,
        d.betAmount,
        d.profit,
      d.status === 1
  ? "Win"
  : d.status === 2
  ? "Loss"
  : d.status === 4
  ? "Bet Deleted"
  : "Pending"
,
        d.date,
      ]),
      theme: "striped",
      styles: { fontSize: 8 },
    });

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 10,
      head: [
        [
          "User ID",
          "Game Code",
          "Game Name",
          "Price",
          "Profit/Loss",
          "Status",
          "Placed Date",
        ],
      ],
      body: filteredCasino.map((d) => [
        d.playerId,
        d.gameId,
        d.gameName,
        d.price,
        d.profit,
        d.status === 1 ? "Win" : d.status === 2 ? "Loss" : "Pending",
        d.date,
      ]),
      theme: "striped",
      styles: { fontSize: 8 },
    });

    doc.save(`BetHistory_${user_phone}.pdf`);
  };

  return (
    <div className="wrapper">
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />
      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      <div
        className={`content-wrapper d-flex flex-column ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{
          marginLeft: !isMobile && isSidebarOpen ? "" : "0",
          transition: "margin-left 0.3s ease",
        }}
      >
        <section className="content-header">
          <div className="container-fluid">
            <h1>Bet History of: {user_phone}</h1>
          </div>
        </section>

        <div className="container-fluid">
          {/* Filters */}
          <div className="card mb-3 p-3">
            <div className="row g-3 align-items-center">
              <div className="col-md-3">
                <label>From Date:</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <label>To Date:</label>
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <div className="col-md-4 d-flex align-items-end gap-2">
                <button
                  className="btn btn-dark"
                  onClick={() => setStatusFilter(null)}
                >
                  All
                </button>
                <button
                  className="btn btn-success"
                  onClick={() => setStatusFilter(1)}
                >
                  Win
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => setStatusFilter(2)}
                >
                  Loss
                </button>
                <button
                  className="btn btn-warning text-dark"
                  onClick={() => setStatusFilter(0)}
                >
                  Pending
                </button>
              </div>
              <div className="col-md-2 d-flex align-items-end">
                <button
                  className="btn btn-secondary w-100"
                  onClick={downloadPDF}
                >
                  Download PDF
                </button>
              </div>
            </div>
            {statusFilter === 0 && (
              <div className="mt-3 text-center text-danger fs-5">
                Total Pending Bet Amount: ₹{pendingSum}
              </div>
            )}
          </div>

          {/* ✅ Casino Bets */}
          <div className="card mb-4">
            <div className="card-header bg-secondary text-white">
              Casino Bets
            </div>
            <div className="card-body table-responsive">
              <table className="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th>User ID</th>
                    <th>Game Code</th>
                    <th>Game Name</th>
                    <th>Price</th>
                    <th>Profit / Loss</th>
                    <th>Status</th>
                    <th>Placed Date</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCasino.length ? (
                    filteredCasino.map((d) => (
                      <tr key={d.id}>
                        <td>{d.playerId}</td>
                        <td>{d.gameId}</td>
                        <td>{d.gameCategory}</td>
                        <td>{d.amount}</td>
                        <td>{d.profit}</td>
                      <td className="text-center bb">
  <span
    className="rounded px-2"
    style={{
      background:
        d?.status === "lose"
          ? "rgb(255,0,0)"
          : d?.status === "pending"
          ? "orange"
          : "rgb(3,187,22)",
      color: "#fff",
    }}
  >
    {d?.status === "pending" ? "Rollback" : d?.status}
  </span>
</td>

                        {/* <td>{d.time}</td> */}
                        <td>{d.time.split(" ")[0]}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center">
                        No Casino Bets Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Sports Table */}
          <div className="card mb-4">
            <div className="card-header bg-primary text-white">Sports Bets</div>
            <div className="card-body table-responsive">
              <table className="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th>User ID</th>
                    {/* <th>Tournament</th> */}
                    <th>Match</th>
                    <th>Side</th>
                    <th>Odds</th>
                    <th>Stake</th>
                    <th>P/L</th>
                    <th>Status</th>
                    <th>Placed At</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredSports.length ? (
                    filteredSports.map((d) => (
                      <tr key={d.id}>
                        {/* <td>{d.phone}</td> */}
                        <td>{d.gameId}</td>
                        <td>{d.eventName}</td>
                        <td>
                          <span
                            className="px-2 text-white rounded"
                            style={{
                              backgroundColor:
                                d.side === "Back" ? "blue" : "red",
                            }}
                          >
                            {d.side}
                          </span>
                        </td>
                        <td>{d.betprice}</td>
                        <td>{d.betAmount}</td>
                        <td
                          style={{
                            color:
                              d.status === 1
                                ? "green"
                                : d.status === 2
                                ? "red"
                                : "blue",
                          }}
                        >
                          {d.profit}
                        </td>
                        <td>
                          <span
                            className="px-2 text-white rounded"
                            style={{
                              backgroundColor:
                                d.status === 1
                                  ? "green"
                                  : d.status === 2
                                  ? "red"
                                  : "gray",
                            }}
                          >
                            {d.status === 1
  ? "Win"
  : d.status === 2
  ? "Loss"
  : d.status === 4
  ? "Bet Deleted"
  : "Pending"}
                          </span>
                        </td>
                        <td>{d.date}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center">
                        No Sports Bets Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Fancy Table */}
          <div className="card">
            <div className="card-header bg-warning text-white">Fancy Bets</div>
            <div className="card-body table-responsive">
              <table className="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th>User ID</th>
                    <th>Tournament</th>
                    <th>Match</th>
                    <th>Side</th>
                    <th>Odds</th>
                    <th>Stake</th>
                    <th>P/L</th>
                    <th>Status</th>
                    <th>Placed At</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredFancy.length ? (
                    filteredFancy.map((d) => (
                      <tr key={d.id}>
                        <td>{d.phone}</td>
                        <td>{d.gameId}</td>
                        <td>{d.eventName}</td>
                        <td>
                          <span
                            className="px-2 text-white rounded"
                            style={{
                              backgroundColor:
                                d.side === "yes"
                                  ? "green"
                                  : d.side === "no"
                                  ? "red"
                                  : "gray",
                            }}
                          >
                            {d.side}
                          </span>
                        </td>
                        <td>{d.betprice}</td>
                        <td>{d.betAmount}</td>
                        <td
                          style={{
                            color:
                              d.status === 0
                                ? "green"
                                : d.status === 2
                                ? "red"
                                : "blue",
                          }}
                        >
                          {d.profit}
                        </td>
                        <td>
                          <span
                            className="px-2 text-white rounded"
                            style={{
                              backgroundColor:
                                d.status === 1
                                  ? "green"
                                  : d.status === 2
                                  ? "red"
                                  : "gray",
                            }}
                          >
                            {d.status === 1
                              ? "Win"
                              : d.status === 2
                              ? "Loss"
                              : "Pending"}
                          </span>
                        </td>
                        <td>{d.time.split('T')[0]}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center">
                        No Fancy Bets Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserBetHistory;
